{
  "abort": {
    "action": "Invoer afbreken",
    "description": "<p>Ga je op een later moment verder met het invoeren van dit stembureau? Dan kan je de invoer die je al hebt gedaan bewaren.</p><p>Twijfel je? Overleg dan met de coördinator.</p>",
    "discard_input": "Verwijder invoer",
    "save_input": "Invoer bewaren",
    "title": "Wat wil je doen met je invoer?"
  },
  "changes_are_not_saved": "Je laatste wijzigingen worden niet opgeslagen.",
  "completed": {
    "all_entries_completed": "Alle stembureaus zijn ingevoerd",
    "info": "De resultaten van alle stembureaus kunnen nu opgeteld gaan worden om de uitkomst van de {electionName} vast te stellen.",
    "thank_you": "Bedankt voor je hulp!",
    "wait_for_instructions": "Wacht op instructies van de coördinator."
  },
  "continue_after_check": "Je kan alleen verder als je het papieren proces-verbaal hebt gecontroleerd.",
  "continue_with_errors": "Je kan alleen verder als je dit met de coördinator hebt overlegd.",
  "corrected": "Gecorrigeerd",
  "current_form": "het huidige formulier",
  "data_entry_not_possible": "Je kan dit stembureau niet invoeren",
  "definitive": "Definitief",
  "entry_different_1": "Let op: verschil met tweede invoer",
  "entry_different_2": "Let op: verschil met eerste invoer",
  "entry_different_message_1": "Je invoer is opgeslagen. Geef het papieren proces-verbaal terug aan de coördinator,\nen geef aan dat er een verschil is met de tweede invoer.",
  "entry_different_message_2": "Je invoer is opgeslagen. Geef het papieren proces-verbaal terug aan de coördinator,\nen geef aan dat er een verschil is met de eerste invoer.",
  "entry_errors": "Let op: fouten in het proces-verbaal",
  "entry_errors_message": "Je invoer is opgeslagen. Geef het papieren proces-verbaal terug aan de coördinator,\nen geef aan dat je daarin fouten hebt gevonden.",
  "entry_saved_1": "Eerste invoer is opgeslagen",
  "entry_saved_2": "Tweede invoer is opgeslagen",
  "entry_saved_message_1": "Geef het papieren proces-verbaal terug aan de coördinator.\nEen andere invoerder doet straks de tweede invoer.",
  "entry_saved_message_2": "Geef het papieren proces-verbaal terug aan de coördinator.",
  "first_entry": "1e invoer",
  "form_accept_warnings": "Ik heb mijn invoer gecontroleerd met het papier en correct overgenomen.",
  "form_accept_errors": "Ik heb de fouten besproken met de coördinator",
  "list": {
    "not_found": "Geen lijst gevonden voor {listNumber}"
  },
  "original": "Oorspronkelijk",
  "pick_polling_station": "Kies een stembureau",
  "save_changes": "Wil je deze wijzigingen bewaren?",
  "second_entry": "2e invoer",
  "title": "Invoeren",
  "to_overview": "Naar startscherm",
  "unsaved_changes_message": "Je hebt in <strong>{name}</strong> wijzigingen gemaakt die nog niet zijn opgeslagen.",
  "unsaved_changes_title": "Let op: niet opgeslagen wijzigingen"
}
